import React from "react";
import test from "../asset/background.png";

const Hero = () => {
  return (
    <div className="w-full h-full">
      <div className="bg-black/30 absolute top-0 left-0 w-full h-screen" />

      <div className="absolute top-5  w-full h-full flex flex-col justify-center items-center text-white  text-center">
        <div className=" max-w-[1000px] m-auto absolute  ">
          <h1 className="font-bold  text-6xl drop-shadow-2xl max-md:text-3xl hover:{text-6xl, text-black} ">
            <span className=" text-green-600 font-bold font-EBGaramond"> Green Gold Home: </span>
            <b className="font-EBGaramond"> Where Vanilla Beans Flourish </b>
          </h1>
          <p className=" drop-shadow-2xl font-Montserrat font-bold max-md:text-xl  text-2xl py-8">
            Explore an Abundance of Vanilla Beans: Uncover the Essence of Indoor
            and Outdoor Delights.
          </p>
          <a href="#about" className=" bg-transparent font-Montserrat text-3xl hover:bg-green-500 uppercase text-white font-bold hover:text-white py-2 px-2 border border-green-500 hover:border-transparent rounded-2xl">
          Explore US
          </a>
        </div>
      </div>
      
    </div>
    
  );
};

export default Hero;
